<script>
  import { lang } from '$lib/store'
  import { Globe } from '$icons'
  import Icon from '@iconify/svelte/dist/OfflineIcon.svelte'

  export let className = ''
</script>

<button
  class="lang-toggle {className}"
  title="Language / Langue"
  aria-label="Language / Langue"
  on:click={() => ($lang = $lang === 'fr' ? 'en' : 'fr')}
>
  <Icon inline={true} icon={Globe} height="1.2rem" class="fill-current" />
  <span>{$lang === 'fr' ? 'FR' : 'EN'}</span>
</button>

<style>
  .lang-toggle {
    @apply inline-flex cursor-pointer items-center gap-x-1 p-2 text-sm transition;
  }
  .lang-toggle:hover {
    @apply opacity-70;
  }
</style>
